import { useState } from "react"

/**
 * Adapta o loadOptions do AsyncSelect para que uma falha não deixe o campo em "Carregando".
 * A função de busca deve devolver a promise da consulta, além de chamar o callback.
 * Na falha resolve sem opções: o AsyncSelect não guarda esse resultado e a busca pode ser repetida.
 */
const useCarregarOpcoes = loadOptions => {
  const [falhou, setFalhou] = useState(false)

  const carregarOpcoes = inputValue => {
    setFalhou(false)
    return new Promise(resolve => {
      const busca = loadOptions(inputValue, resolve)
      if (busca && typeof busca.then === "function") {
        busca.then(undefined, () => {
          setFalhou(true)
          resolve()
        })
      }
    })
  }

  return { carregarOpcoes, falhou }
}

export default useCarregarOpcoes
